export default {
    approvalFlow: {
        cooperative: {
            delete: 'Hapus',
            deactivate: 'Nonaktifkan',
            activate: 'Aktifkan',
            add: 'Tambah Koperasi Baru',
            edit: 'Edit',
            cooperativeName: 'Nama Koperasi',
            membershipPlan: 'Paket Keanggotaan',
            primaryContact: 'Kontak Utama',
            firstName: 'Nama Depan',
            lastName: 'Nama Belakang',
            phoneNumber: 'Nomor Telepon',
            email: 'Email',
            location: 'Lokasi',
            country: 'Negara',
            provinceState: 'Provinsi/Negara Bagian',
            regionDistrict: 'Wilayah/Kabupaten',
            villageTownCity: 'Desa/Kota',
            address: 'Alamat',
            businessInformation: 'Informasi Bisnis',
            interestedCommodities: 'Komoditas/Produk yang Diminati',
            coffee: 'Kopi',
            cacao: 'Kakao',
            landRegistered: 'Berapa luas lahan yang akan didaftarkan? (dalam hektar)',
            userType: 'Jenis Pengguna',
            exporter: 'Eksportir',
            cooperative: 'Koperasi',
            bothOfThem: 'Keduanya',
            uploadLogo: 'Unggah salinan Logo',
            uploadLogoButton: 'UNGGAH LOGO',
            enterHere: 'Masukkan di sini',
            select: 'Pilih',
            cooperativeNameRequired: 'Nama koperasi wajib diisi',
            firstNameRequired: 'Nama depan wajib diisi',
            emailRequired: 'Email wajib diisi',
            invalidEmail: 'Email tidak valid',
            required: 'Wajib diisi',
            pleaseUploadValidImage: 'Silakan unggah file gambar yang valid',
            errorPreparingData: 'Error mempersiapkan data',
            cancel: 'Batal',
            save: 'Simpan',
            update: 'Perbarui',

            // List page translations
            listOfCooperatives: 'Daftar Koperasi',
            addCooperatives: 'Tambah Koperasi',
            loadingData: 'Memuat data...',
            search: 'Cari',
            type: 'Jenis',
            cooperativeTypeInformation: 'Informasi Jenis Koperasi',
            all: 'Semua',
            of: 'dari',
            active: 'Aktif',
            unregistered: 'Tidak Terdaftar',
            deactivated: 'Dinonaktifkan',
            view: 'Lihat',
            confirmDelete: 'Konfirmasi Hapus',
            areYouSureDeleteCooperative: 'Apakah Anda yakin ingin menghapus koperasi ini?',
            updatedSuccessfully: 'Berhasil diperbarui',
            createdSuccessfully: 'Berhasil dibuat',
            errorFetchingCooperativeDetails: 'Error mengambil detail koperasi',
            errorSavingCooperative: 'Error menyimpan koperasi',
            errorFetchingCooperativesData: 'Error mengambil data koperasi',
            cooperativeDeactivatedSuccessfully: 'Koperasi berhasil dinonaktifkan',
            errorDeactivatingCooperative: 'Error menonaktifkan koperasi',
            cooperativeDeletedSuccessfully: 'Koperasi berhasil dihapus',
            errorDeletingCooperative: 'Error menghapus koperasi',
            // Table headers
            noOfFarms: 'No. Pertanian',
            cropsProducts: 'Tanaman/Produk',
            status: 'Status',
            actions: 'Aksi',
            // Cooperative types
            cooperativeAndExporter: 'Koperasi + Eksportir',
            // Success messages
            cooperativeActivatedSuccessfully: 'Koperasi berhasil diaktifkan',
            back: 'Kembali',
            commoditiesProducts: 'Detail Koperasi',
            cooperativeEmail: 'Email Koperasi',
            cooperativePhoneNumber: 'Nomor Telepon Koperasi',
            logo: 'Logo',
            advanced: 'Lanjutan',

            // Tooltips
             statusTT: 'Status operasional koperasi dalam sistem (e.g., Aktif, Dinonaktifkan, Tidak Terdaftar).',
             logoTT: 'Gambar resmi atau simbol logo Organisasi untuk branding pada laporan/halaman QR.',
             cooperativeNameTT: 'The legal registered name of the cooperative, used in all compliance records and reports. Nama resmi yang terdaftar dalam koperasi, digunakan dalam semua catatan kepatuhan dan laporan.',
             primaryContactTT: 'Nama kontak, email, telepon.',
             locationTT: 'Filter by location text (country/province/city).',
             membershipPlanTT: 'The plan or agreement that outlines the terms and conditions of membership in the cooperative. Paket keanggotaan atau perjanjian yang menjelaskan syarat dan ketentuan keanggotaan dalam koperasi.',
             countryTT: 'The country where the cooperative is legally registered and operates. This helps align reports with national regulations. Negara di mana koperasi terdaftar dan beroperasi. Ini membantu menyesuaikan laporan dengan regulasi nasional.',
             provinceStateTT: 'The province or state where the cooperative is legally registered and operates. This helps align reports with regional regulations. Provinsi atau negara bagian di mana koperasi terdaftar dan beroperasi. Ini membantu menyesuaikan laporan dengan regulasi regional.',
             regionDistrictTT: 'The region or district where the cooperative is based. This helps ensure accurate community-level identification.',
             villageTownCityTT: 'The name of the local settlement (village, town, or city) where the cooperative is based. This ensures accurate community-level identification.',
             addressTT: 'The full physical or postal address of the cooperative. This should include street details, if available, for accurate referencing in reports.',
             interestedCommoditiesTT: 'Displays the product code and name associated with the report. This field helps users understand what product the report is related to.',
             userTypeTT: 'Filter results by Cooperative role/type.',
        },
    },
};
